import React, { useState, useEffect } from "react";
import {
    LocalizationProvider,
    DesktopDatePicker,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Base } from "../../framework/base";
import IconButton from "@mui/material/IconButton";
import { TextFieldProps } from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";

interface ISingleDatePickerProps {
    id?: string;
    value: string;
    label?: string;
    onChange: (val: string) => void;
    error?: boolean;
    helperText?: string;
    required?: boolean;
    fullWidth?: boolean;
    disableInputAdornment?: boolean;
    open?: boolean;
    setOpen?: (open: boolean) => void;
    textFieldProps?: TextFieldProps;
    showCloseIcon?: boolean;
}

export const MuiSingleDatePicker = ({
    id,
    value,
    onChange,
    error,
    helperText,
    required,
    label,
    fullWidth,
    disableInputAdornment,
    open,
    setOpen,
    textFieldProps = {},
    showCloseIcon,
}: ISingleDatePickerProps) => {
    const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(
        value ? dayjs(value) : null
    );

    useEffect(() => {
        setSelectedDate(value ? dayjs(value) : null);
    }, [value]);

    const handleDateChange = (date: Dayjs | null) => {
        setSelectedDate(date);
        if (date) {
            onChange(Base.dayjsToJsonDate(date));
        } else {
            onChange("");
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fi">
            <DesktopDatePicker
                open={open}
                onClose={!!setOpen ? () => setOpen(false) : undefined}
                label={label}
                value={selectedDate}
                onChange={handleDateChange}
                format="D.M.YYYY"
                slots={{
                    toolbar: null,
                    inputAdornment: disableInputAdornment
                        ? () => null
                        : undefined,
                }}
                slotProps={{
                    textField: {
                        id,
                        helperText,
                        error: !!error,
                        required,
                        fullWidth,
                        onClick: !!setOpen ? () => setOpen(true) : undefined,
                        InputProps: { sx: textFieldProps.sx },
                        ...textFieldProps,
                    },
                }}
            />
            {showCloseIcon ? (
                <IconButton size="small" onClick={() => handleDateChange(null)}>
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            ) : null}
        </LocalizationProvider>
    );
};
